import style from './Button.module.scss';

const Button = ({
	title,
	disabled,
	type,
	onClick,
}: {
	title: string;
	disabled?: boolean;
	type: 'button' | 'submit' | 'reset';
	onClick?: () => void;
}) => {
	return (
		<button disabled={disabled} className={style['button']} type={type} onClick={onClick}>
			{title}
		</button>
	);
};

export default Button;
